import axios from 'axios';
import { getEntityConfig } from '@/hooks/useEntityConfig';

const config = getEntityConfig();

export default axios.create({
  baseURL: `${config.VITE_URL_ID_BACKEND}/api/v1`,
});

export const axiosPrivate = axios.create({
  baseURL: `${config.VITE_URL_ID_BACKEND}/api/v1`,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

// IB Desk talks to services/ib-desk, not id-backend: separate base URL, bearer-only auth
// (no cookies — the refresh cookie lives on id-backend and is used by axiosPrivate).
export const axiosIb = axios.create({
  baseURL: config.VITE_URL_IB,
  headers: { 'Content-Type': 'application/json' },
});
